var map = {
	"./": [
		"9923",
		9
	],
	"./config": [
		"d185",
		9
	],
	"./config.js": [
		"d185",
		9
	],
	"./en": [
		"cc06",
		9
	],
	"./en/": [
		"cc06",
		9
	],
	"./en/error": [
		"4746",
		3
	],
	"./en/error.json": [
		"4746",
		3
	],
	"./en/index": [
		"cc06",
		9
	],
	"./en/index.js": [
		"cc06",
		9
	],
	"./index": [
		"9923",
		9
	],
	"./index.js": [
		"9923",
		9
	],
	"./zh-Hant": [
		"e956",
		9
	],
	"./zh-Hant/": [
		"e956",
		9
	],
	"./zh-Hant/dingbeauty-error": [
		"55c7",
		3
	],
	"./zh-Hant/dingbeauty-error.json": [
		"55c7",
		3
	],
	"./zh-Hant/dingbeauty-site": [
		"5039",
		3
	],
	"./zh-Hant/dingbeauty-site.json": [
		"5039",
		3
	],
	"./zh-Hant/index": [
		"e956",
		9
	],
	"./zh-Hant/index.js": [
		"e956",
		9
	],
	"./zh-Hant/ipetbooking-error": [
		"3796",
		3
	],
	"./zh-Hant/ipetbooking-error.json": [
		"3796",
		3
	],
	"./zh-Hant/ipetbooking-site": [
		"567f",
		3
	],
	"./zh-Hant/ipetbooking-site.json": [
		"567f",
		3
	],
	"./zh-Hant/massage-error": [
		"c998",
		3
	],
	"./zh-Hant/massage-error.json": [
		"c998",
		3
	],
	"./zh-Hant/massage-site": [
		"e0ab",
		3
	],
	"./zh-Hant/massage-site.json": [
		"e0ab",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;